"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlQuery = void 0;
var tslib_1 = require("tslib");
var queryString = tslib_1.__importStar(require("query-string"));
var getUrlQuery = function (_a) {
    var queryNames = _a.queryNames, search = _a.search;
    var parsedQuery = search ? queryString.parse(search) : {};
    var query = {};
    for (var _i = 0, _b = Object.entries(queryNames); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], queryName = _c[1];
        query[key] = parsedQuery[queryName];
    }
    return query;
};
exports.getUrlQuery = getUrlQuery;
